export const BUSKING_BASE_PATH = `/busking`;
export const RoutesList = {
  BUSKING_HOME: BUSKING_BASE_PATH,
  ISSUE_TYPE: BUSKING_BASE_PATH + '/issue-type',
  ISSUE_DETAILS: BUSKING_BASE_PATH + '/issue-details',
  ISSUE_DATE_TIME: BUSKING_BASE_PATH + '/issue-date-time',
  PHOTO_UPLOAD: BUSKING_BASE_PATH + '/photo-upload',
  ISSUE_LOCATION: BUSKING_BASE_PATH + '/issue-location',
  CONTACT_USER_OPTION: BUSKING_BASE_PATH + '/can-we-contact-you',
  EMAIL_CONFIRMATION_REPORT: BUSKING_BASE_PATH + '/email-confirmation-report',
  YOUR_DETAILS: BUSKING_BASE_PATH + '/your-details',
  CONFIRMATION: BUSKING_BASE_PATH + '/confirmation',
  CALLBACKS: BUSKING_BASE_PATH + '/callbacks/*',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.ISSUE_TYPE,
      RoutesList.ISSUE_DETAILS,
      RoutesList.ISSUE_DATE_TIME,
    ],
  },
  {
    label: 'Photos ',
    urlPaths: [RoutesList.PHOTO_UPLOAD],
  },
  {
    label: 'Location',
    urlPaths: [RoutesList.ISSUE_LOCATION],
  },
  {
    label: 'Your details',
    urlPaths: [
      RoutesList.EMAIL_CONFIRMATION_REPORT,
      RoutesList.CONTACT_USER_OPTION,
      RoutesList.YOUR_DETAILS,
    ],
  },
];
